import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
// eslint-disable-next-line no-unused-vars
import { Line, Pie } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'bottom',
    }
  },
  scales: {
    y: {
      beginAtZero: true,
      min: 0,
      ticks: {
        precision: 0
      }
    }
  }
};

export function RenderdChart({charttype = "Line", data, }) {
  switch(charttype){
    case 'pie':
      return (
        <div style={{ height: '220px', position: 'relative' }}>
          <Pie options={options} data={data} />
        </div>
      );
    default: 
      return (
        <div style={{ height: '220px', position: 'relative' }}>
          <Line options={options} data={data} />
        </div>
      );
  }
}
